export default class Helpers {
  /**
   * Gera um ID único baseado no timestamp atual e um número aleatório.
   * @param {string} prefix O prefixo a ser adicionado ao ID (opcional).
   * @returns {string} Uma string com o ID gerado.
   */
  static generateUniqueId(prefix: string = 'br'): string {
    const timestamp = Date.now().toString(36) // Data atual na base-36
    const random = Math.random().toString(36).substring(2, 8) // Parte aleatória na base-36
    return `${prefix}-${timestamp}-${random}`
  }
}
